<form name="form" #formWithdrawn="ngForm" class="stewards-modal" (ngSubmit)="formWithdrawn.form.valid && save()">
  <div class="modal-header stewards-modal-header">
    <h4 class="modal-title text-truncate">Withdrawn Info for {{meta.title}}</h4>
    <button type="button" class="stewards-modal-close" (click)="cancel('cancel')" aria-label="Close">
      <fa name="times"></fa>
    </button>
  </div>
  <div class="modal-body stewards-modal-body" *ngIf="meta.loading">
    <div class="row">
      <div class="col text-center">
        <fa name="circle-o-notch" size="2x" animation="spin"></fa>
      </div>
    </div>
  </div>
  <div class="modal-body stewards-modal-body" *ngIf="!meta.loading">
    <div class="row" *ngIf="withdrawnInfo">
      <div class="col">
        <div class="form-group">
          <label class="stewards-modal-label" for="reason">Reason</label>
          <select
            class="custom-select"
            #reason="ngModel"
            name="reason"
            [(ngModel)]="withdrawnInfo.reasonId"
            required
          >
            <option *ngFor="let item of possibleReasons" [value]="item.id">{{item.reason}}</option>
          </select>
          <div *ngIf="formWithdrawn.submitted && reason.invalid">
            <div class="alert alert-danger" *ngIf="reason.errors.required">A Reason is required</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="withdrawnInfo">
      <div class="col">
        <div class="form-group">
          <label class="stewards-modal-label" for="comment">Comment</label>
          <textarea class="form-control textarea-height" id="comment" name="comment" [(ngModel)]="withdrawnInfo.comment"></textarea>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="withdrawnInfo">
      <div class="col">
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="h6RuleApplied" name="h6RuleApplied" [(ngModel)]="withdrawnInfo.h6RuleApplied">
            <label class="custom-control-label" for="h6RuleApplied">(H)6 Rule applied</label>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="withdrawnInfo">
      <div class="col">
        <div class="form-group">
          <label class="stewards-modal-label" for="internalComment">Internal Comment</label>
          <textarea class="form-control textarea-height" id="internalComment" name="internalComment" [(ngModel)]="withdrawnInfo.internalComment"></textarea>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="withdrawnInfo">
      <div class="col col-lg-3 offset-lg-3">
        <div class="form-group">
          <label class="stewards-modal-label" for="declaredDate">Declared Date</label>
          <div class="input-group calendar-open-up" container="body">
            <input class="form-control" placeholder="dd-mm-yyyy" id="declaredDate" name="declaredDate" [(ngModel)]="declared.date" ngbDatepicker #declaredDate="ngbDatepicker" (click)="declaredDate.toggle(); $event.stopPropagation();" (document:click)="datepickerFix($event, declaredDate)">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" (click)="declaredDate.toggle(); $event.stopPropagation();" type="button">
                <fa name="calendar"></fa>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <label class="stewards-modal-label" for="declaredTime">Declared Time</label>
        <ngb-timepicker id="declaredTime" name="declaredTime" [(ngModel)]="declared.time" [spinners]="false"></ngb-timepicker>
      </div>
    </div>
  </div>
  <div *ngIf="!meta.saving" class="modal-footer stewards-modal-footer">
    <button type="button" class="btn btn-outline-dark stewards-modal-btn-close" (click)="cancel('cancel')">Close</button>
    <button type="submit" class="btn btn-primary" [disabled]="!withdrawnInfo">Save</button>
  </div>
  <div *ngIf="meta.saving" class="modal-footer stewards-modal-footer stewards-modal-footer-loading">
    <fa name="circle-o-notch" animation="spin"></fa>
  </div>
</form>
